import React from "react"
import { isEmpty } from "lodash"
import "./_style.scss"

// Atoms
import TileContent from "§/src/components/atoms/content/tile-content"
import InvestorTile from "§/src/components/atoms/content/tile-content-investor"

// Assets
import PatternDashed from "§/src/images/svg/pattern-dashed.svg"
import Clock from "§/src/images/svg/clock.svg"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

const InvestorCards3el = props => {
  const linkCards = props.data
  const investorCard = props.investor
  const news = props.news

  return !isEmpty(linkCards) ? (
    <div comp="investor-c3el" className="row pb-4">
      <InvestorTile
        className="investor-card tile-content temp-blue temp-pattern col-md-4"
        data={investorCard}
      />

      {!!news && <TileContent data={news} noFollow="true" className="col-md-4" />}

      {linkCards.map((card, index) => {
				if(index === 1){
					return <TileContent key={index} data={card} className="col-md-4" />
				}
      })}
    </div>
  ) : (
    ""
  )
}

export default InvestorCards3el
